/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UserName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function UserName({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Status/Content/Content/UserName"
  
}) {
let statusUserValueData = fromData.useDataFormat({ viewPath,
context: 'status',
path: 'user',
format: fromFormat.statusPersonName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="status.user"
 format="/Data/format.js statusPersonName"
 text={statusUserValueData}
/>
{children}
</React.Fragment>)
}